import { useState, useEffect, useRef } from "react";

interface UseFetchI {
  fetchFunction: (args: any, setSuccess: (value: boolean) => void) => void;
  dependency?: any;
}

const useFetch = (
  { fetchFunction, dependency = null }: UseFetchI,
  ...args: any[]
) => {
  const [success, setSuccess] = useState(false);

  const firstMount = useRef(true);

  useEffect(() => {
    firstMount.current = false;
  }, []);

  useEffect(() => {
    if (firstMount.current) setSuccess(false);
    // @ts-ignore
    fetchFunction(...args, setSuccess);
  }, [dependency]);

  return [success];
};

export default useFetch;
